const zhCht = {
  'appManuals.downloadHelpText': '下載的檔案可以透過網際網路瀏覽器或PDF閱讀器軟體查看。',
  'appManuals.systemRequirements':
    '硬件要求 (推荐): Intel® Core™ i3或更高CPU, 4 GB或更多内存, 100 MB或更多自由存储空间用于PDF保存。',
  'appManuals.medicalsoftware.helptext': '國家可能會有不同的醫療軟體。',
  '이미 등록된 라이선스가 있습니다.': '已存在已註冊的授權。',
  '갱신 가능한 기존 라이선스를 찾을 수 없습니다.': '找不到可續訂的現有授權。',
  '발급 가능한 잔여 수량이 없습니다.': '沒有可發放的剩餘數量。',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': '顯示所有手冊',
  'This site complies with the General Data Protection Regulation (EU 2016/679).': '本網站符合《一般資料保護規範》(EU 2016/679)。',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).': '本網站滿足《一般資料保護規範》(EU 2016/679)的要求。',
  'the content of this site is protected against unauthorized modification.': '本網站的內容受到保護，防止未經授權的修改。',
  'Previous versions of the User Manual are available for viewing and downloading via search.': '可透過搜尋查看與下載使用手冊的舊版本。',
  'Checking the latest documents.': '正在檢查最新文件。',
  'There are no manuals to display.': '沒有可顯示的手冊。',
  'Manuals': '手冊',
  'Product Name': '產品名稱',
  'Language': '語言',
  'Document Name': '文件名稱',
  'Product': '產品',
  'Revision': '修訂',
  'Document': '文件',
  'Published': '發佈日期',
  'English': '英語',
  'Korean': '韓語',
  'Japanese': '日語',
  'German': '德語',
  'Russian': '俄語',
  'Chinese (Simplified)': '簡體中文',
  'Chinese (Traditional)': '繁體中文',
  'Country': '國家',
  'eifuPortalIntro': '搜尋並下載 RAY 醫療器材軟體的電子使用說明書（eIFU）。',
  "criticalNotice.badge": "重要通知",
  "criticalNotice.close": "關閉",
};

export default zhCht;
